package com.cybersoftsolution.cybersoftsolutionweb.navigation


import com.cybersoftsolution.cybersoftsolutionweb.api.buildParams
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.navigation.UpdateHistoryMode


    fun PageContext.navigateTo(screen: Screen,params : MutableMap<String, Any?> = mutableMapOf()){


        this.router.navigateTo(
            pathQueryAndFragment = screen.route+params.buildParams(),
            UpdateHistoryMode.REPLACE,
            OpenLinkStrategy.IN_PLACE,
        )
    }